import { Helmet } from 'react-helmet-async';
import { useState, useEffect, useRef } from 'react';
import {
  Card,
  Stack,
  Typography,
  TextField,
  Button,
  IconButton,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  TableSortLabel,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  CircularProgress,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import DescriptionIcon from '@mui/icons-material/Description';
import EditIcon from '@mui/icons-material/Edit';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import MopedIcon from '@mui/icons-material/Moped';
import CloseIcon from '@mui/icons-material/Close';

import CustomFilter from 'src/components/filter/CustomFilter';
import ClearButton from 'src/components/shared/ClearButton';
import FilterButton from 'src/components/shared/FilterButton';

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

import { tokenService } from 'src/services';
import Services from 'src/services/Services';

function GoogleMapSelector({
  onLocationSelect,
  initialLocation,
  initialAddress,
}) {
  const mapRef = useRef(null);
  const [mapLoaded, setMapLoaded] = useState(false);
  const apiKey = 'AIzaSyByvfX7mgCvxiti1aSmeZ3xs3-up0HWCB0';

  useEffect(() => {
    if (!window.google) {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
      script.async = true;
      script.onload = () => setMapLoaded(true);
      document.head.appendChild(script);
    } else {
      setMapLoaded(true);
    }
  }, [apiKey]);

  useEffect(() => {
    if (!mapLoaded || !mapRef.current) return;
    const map = new window.google.maps.Map(mapRef.current, {
      center: initialLocation || { lat: 41.0082, lng: 28.9784 },
      zoom: 15,
    });
    let marker = new window.google.maps.Marker({
      position: map.getCenter(),
      map,
      draggable: true,
    });
    map.addListener('click', (e) => {
      const newLatLng = { lat: e.latLng.lat(), lng: e.latLng.lng() };
      marker.setPosition(newLatLng);
      onLocationSelect(newLatLng);
    });
    marker.addListener('dragend', (e) => {
      const newLatLng = { lat: e.latLng.lat(), lng: e.latLng.lng() };
      onLocationSelect(newLatLng);
    });
    if (initialAddress) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address: initialAddress }, (results, status) => {
        if (status === 'OK' && results[0]) {
          map.setCenter(results[0].geometry.location);
          marker.setPosition(results[0].geometry.location);
        }
      });
    }
  }, [mapLoaded, initialLocation, initialAddress, onLocationSelect]);

  return <div ref={mapRef} style={{ width: '100%', height: '100%' }} />;
}

// ----------------------------------------------------------------------

export default function CargoCourierPage() {
  const [requests, setRequests] = useState([]);
  const [filteredRequests, setFilteredRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    searchText: '',
    source: '',
    senderType: '',
    type: '',
  });
  const [filterModal, setFilterModal] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalStep, setModalStep] = useState(0);
  const [formType, setFormType] = useState('');
  const [formData, setFormData] = useState({
    gondericiAd: '',
    gondericiSoyad: '',
    telefon: '',
    email: '',
    tckn: '',
    bireyselKurumsal: '',
    gondericiCity: '',
    gondericiTown: '',
    gondericiAcikAdres: '',
    icerikKategori: '',
    paketAdedi: 1,
    city: '',
    district: '',
    town: '',
    aliciAdSoyad: '',
    aliciAd: '',
    aliciSoyad: '',
    aliciTelefon: '',
    acikAdres: '',
    kuryeModel: 'MotorCourier',
    adresTarifi: '',
    additionalNote: '',
    receiverEmail: '',
    receiverZipcode: '',
  });
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [userData, setUserData] = useState(null);
  const [apiToken, setApiToken] = useState(null);
  const [cities, setCities] = useState([]);
  const [towns, setTowns] = useState([]);
  const [gondericiTowns, setGondericiTowns] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [priceDetails, setPriceDetails] = useState(null);
  const [successData, setSuccessData] = useState(null);
  const [selectedStore, setSelectedStore] = useState(null);
  const [mapModalOpen, setMapModalOpen] = useState(false);
  const [addressNotFoundModalOpen, setAddressNotFoundModalOpen] =
    useState(false);
  const [selectedLatLng, setSelectedLatLng] = useState(null);
  const [cargoPackages, setCargoPackages] = useState([]);
  const [currentPackage, setCurrentPackage] = useState({
    icerikKategori: '',
    agirlik: '',
    en: '',
    boy: '',
    yukseklik: '',
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('date');
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [cardName, setCardName] = useState('');
  const [cardNumber, setCardNumber] = useState('');
  const [expiredDate, setExpiredDate] = useState('');
  const [cvv, setCvv] = useState('');
  const [paymentFormErrors, setPaymentFormErrors] = useState({});
  const [conversationID, setConversationID] = useState('');
  const [iframeSrc, setIframeSrc] = useState(null);
  const [orderLoading, setOrderLoading] = useState(false);
  const [cashPosModalOpen, setCashPosModalOpen] = useState(false);
  const [pendingPaymentType, setPendingPaymentType] = useState('');
  const intervalRef = useRef(null);
  const [cargoLabelData, setCargoLabelData] = useState(null);
  const [lastPaymentMethod, setLastPaymentMethod] = useState('');

  const categories = [
    'Kitap',
    'Kıyafet',
    'Yiyecek',
    'Teknoloji',
    'Elektronik',
    'Diğer',
  ];
  const kargoFirms = [{ label: 'Kargoist', value: 'Kargoist' }];
  const kuryeFirms = [{ label: 'Vigo', value: 'Vigo' }];

  useEffect(() => {
    const initApiData = async () => {
      try {
        const userDataString = localStorage.getItem('user');
        const userData = JSON.parse(userDataString);
        const parsedUserData = JSON.parse(userDataString);
        setUserData(parsedUserData);
        const userToken = userData.token;
        console.log('Token başarıyla alındı:', userToken);
        console.log(userData);
        setApiToken(userToken);
        const citiesRes = await Services.GetCities(userToken);
        console.log(citiesRes.data);
        setCities(citiesRes.data.result || []);
      } catch (err) {
        setError('API token veya şehir bilgisi alınamadı.');
      }
    };
    initApiData();
    fetchRequests();
  }, []);

  useEffect(() => {
    if (!apiToken || !formData.city) {
      setTowns([]);
      setFormData((f) => ({ ...f, district: '' }));
      return;
    }
    const selectedCity = cities.find((c) => c.name === formData.city);
    if (!selectedCity) return;
    const fetchTownsForCity = async () => {
      try {
        const res = await Services.GetTowns(apiToken, selectedCity.code);
        setTowns(res.data.result || []);
      } catch (err) {
        console.error('Alıcı ilçeleri çekilirken hata:', err);
      }
    };
    fetchTownsForCity();
  }, [apiToken, formData.city, cities]);

  useEffect(() => {
    if (!apiToken || !formData.gondericiCity) {
      setGondericiTowns([]);
      setFormData((f) => ({ ...f, gondericiTown: '' }));
      return;
    }
    const selectedCity = cities.find((c) => c.name === formData.gondericiCity);
    if (!selectedCity) return;
    const fetchTownsForSender = async () => {
      try {
        const res = await Services.GetTowns(apiToken, selectedCity.code);
        setGondericiTowns(res.data.result || []);
      } catch (err) {
        console.error('Gönderici ilçeleri çekilirken hata:', err);
      }
    };
    fetchTownsForSender();
  }, [apiToken, formData.gondericiCity, cities]);

  useEffect(() => {
    if (!apiToken || !formData.district) {
      setDistricts([]);
      setFormData((f) => ({ ...f, town: '' }));
      return;
    }
    const selectedTown = towns.find((t) => t.name === formData.district);
    if (!selectedTown) return;
    const fetchRegionsForTown = async () => {
      try {
        const res = await Services.GetRegions(apiToken, selectedTown.code);
        setDistricts(res.data.result || []);
      } catch (err) {
        console.error('Mahalleler çekilirken hata:', err);
      }
    };
    fetchRegionsForTown();
  }, [apiToken, formData.district, towns]);

  useEffect(() => {
    const mallID = localStorage.getItem('mallID');
    const branchID = localStorage.getItem('branchID');
    if (tokenService.getUser()?.accountCategory === 'store') {
      setSelectedStore(
        tokenService
          .getUser()
          ?.authLocations?.branch.find((item) => item.branchID === branchID)
      );
    } else {
      setSelectedStore(
        tokenService
          .getUser()
          ?.authLocations?.mall.find((item) => item.id === mallID)
      );
    }
  }, []);

  useEffect(() => {
    if (!conversationID) return;

    const price = priceDetails?.price || 0;
    const cardNo = cardNumber.replace(/\s/g, '');

    Services.PaymentWith3D(
      conversationID,
      price,
      formData.gondericiAd,
      formData.gondericiSoyad,
      formData.telefon,
      cardName,
      cardNo,
      expiredDate.slice(-2),
      expiredDate.slice(0, 2),
      cvv
    )
      .then((res) => {
        if (res.data.status) {
          const htmlContent = res.data.result;
          const blob = new Blob([htmlContent], { type: 'text/html' });
          const url = URL.createObjectURL(blob);
          setIframeSrc(url);
        } else {
          setIframeSrc(null);
          setPaymentFormErrors({
            api: res.data.message || 'Ödeme başlatılamadı.',
          });
        }
      })
      .catch(() => {
        setIframeSrc(null);
      });
  }, [conversationID]);

  useEffect(() => {
    if (iframeSrc && conversationID) {
      intervalRef.current = setInterval(() => {
        Services.ListenPayment(conversationID)
          .then(async (res) => {
            if (res.data.status && res.data.result === '1') {
              clearInterval(intervalRef.current);
              setIframeSrc(null);
              setOrderLoading(true);
              await handleCreateRequest('online-payment');
              setOrderLoading(false);
            } else if (res.data.result === '2') {
              clearInterval(intervalRef.current);
              setIframeSrc(null);
            }
          })
          .catch(() => {
            clearInterval(intervalRef.current);
          });
      }, 3000);
    }
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [iframeSrc, conversationID]);

  const fetchRequests = async () => {
    setLoading(true);
    setError(null);
    try {
      let pointID = null;
      const currentUser = tokenService.getUser();

      if (!currentUser) {
        throw new Error('Kullanıcı bilgisi bulunamadı.');
      }
      if (currentUser.accountCategory === 'store') {
        try {
          const userBranchID = currentUser.branchID;
          const currentBranch = currentUser.authLocations?.branch.find(
            (b) => b.branchID === userBranchID
          );

          pointID = currentBranch?.mall?.[0]?.points?.malkabul?.id;

          if (!pointID) {
            console.warn(
              "fetchRequests: Malkabul pointID'si bulunamadı. Fallback kullanılacak."
            );
          }
        } catch (e) {
          console.error("fetchRequests için malkabul ID'si alınırken hata:", e);
        }
      }
      if (!pointID) {
        pointID = currentUser.firstResponsibleOffice?.id;
      }
      if (!pointID) {
        setError("Talepleri listelemek için geçerli bir 'pointID' bulunamadı.");
        setLoading(false);
        return;
      }
      const res = await Services.GetThirdPartyCargoCourierPosts(pointID);
      if (res.data.status && Array.isArray(res.data.result)) {
        const mappedData = res.data.result.map((item) => {
          const isCargo = item.type === 'cargo';
          const talepTuru = isCargo ? 'Kargo' : 'Kurye';

          let talepFirmasi = 'Bilinmiyor';
          if (item.apiUserType === 'kargoist') {
            talepFirmasi = 'Kargoist';
          } else if (item.apiUserType === 'vigo') {
            talepFirmasi = 'Vigo';
          }

          const quantity = isCargo
            ? item.dataJson?.consignments?.[0]?.partCount || 1
            : 1;

          let status = 'Aktif',
            state = 'Yolda';
          const deliveryState = item.resultJson?.deliveryState;
          if (deliveryState === 'delivered') {
            status = 'Teslim Edildi';
            state = 'Teslim Edildi';
          } else if (deliveryState === 'cancelled') {
            status = 'İptal';
            state = 'İptal Edildi';
          }
          return {
            id: item.orderNumber || item.id,
            requester: `${item.senderName || ''} ${item.senderLastname || ''}`,
            type: talepTuru,
            source: talepFirmasi,
            requestNo: item.orderNumber || item.id,
            phone: item.receiverPhone,
            senderType: 'Bireysel',
            category: item.productType,
            date: new Date(Number(item.createdDateTime) * 1000).toLocaleString(
              'tr-TR'
            ),
            quantity: quantity,
            status: status,
            state: state,
          };
        });

        setRequests(mappedData);
        setFilteredRequests(mappedData);
      } else {
        setRequests([]);
        setFilteredRequests([]);
      }
    } catch (err) {
      setError('Talepler yüklenirken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = () => {
    setModalOpen(true);
    setModalStep(0);
    resetFormAndState(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    resetFormAndState(false);
  };

  const resetFormAndState = (isOpening) => {
    setFormType('');
    if (!isOpening) {
      setFormData({
        gondericiAd: '',
        gondericiSoyad: '',
        telefon: '',
        email: '',
        tckn: '',
        bireyselKurumsal: 'Bireysel',
        gondericiCity: '',
        gondericiTown: '',
        gondericiAcikAdres: '',
        icerikKategori: '',
        paketAdedi: 1,
        length: '',
        width: '',
        height: '',
        city: '',
        district: '',
        town: '',
        aliciAdSoyad: '',
        aliciAd: '',
        aliciSoyad: '',
        aliciTelefon: '',
        acikAdres: '',
        kuryeModel: '',
        adresTarifi: '',
        additionalNote: '',
      });
    }
    setFormErrors({});
    setPriceDetails(null);
    setSuccessData(null);
    setIsSubmitting(false);
    setCargoPackages([]);
    setCurrentPackage({
      icerikKategori: '',
      agirlik: '',
      en: '',
      boy: '',
      yukseklik: '',
    });
    setSelectedLatLng(null);
    setCargoLabelData(null);
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.gondericiAd) errors.gondericiAd = 'Zorunlu';
    if (!formData.gondericiSoyad) errors.gondericiSoyad = 'Zorunlu';
    if (!formData.telefon) {
      errors.telefon = 'Geçerli telefon girin.';
    } else if (formData.telefon.startsWith('0')) {
      errors.telefon = "Telefon no '0' ile başlamamalı.";
    } else if (!/^\d{10}$/.test(formData.telefon)) {
      errors.telefon = 'Telefon no 10 haneli olmalıdır.';
    }
    if (!formData.email || !/\S+@\S+\.\S+/.test(formData.email))
      errors.email = 'Geçerli e-mail';
    if (!formData.icerikKategori) errors.icerikKategori = 'Zorunlu';
    if (!formData.city) errors.city = 'Zorunlu';
    if (!formData.district) errors.district = 'Zorunlu';

    if (!formData.aliciTelefon) {
      errors.aliciTelefon = 'Geçerli telefon girin.';
    } else if (formData.aliciTelefon.startsWith('0')) {
      errors.aliciTelefon = "Telefon no '0' ile başlamamalı.";
    } else if (!/^\d{10}$/.test(formData.aliciTelefon)) {
      errors.aliciTelefon = 'Telefon no 10 haneli olmalıdır.';
    }

    if (!formData.acikAdres) errors.acikAdres = 'Zorunlu';
    if (formType === 'kargo') {
      if (!formData.tckn || !/^\d{11}$/.test(formData.tckn))
        errors.tckn = 'TCKN 11 haneli olmalıdır.';
      if (!formData.aliciAd) errors.aliciAd = 'Zorunlu';
      if (!formData.aliciSoyad) errors.aliciSoyad = 'Zorunlu';
    }
    if (formType === 'kurye') {
      if (!formData.aliciAdSoyad) errors.aliciAdSoyad = 'Zorunlu';
      if (!formData.kuryeModel) errors.kuryeModel = 'Zorunlu';
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleCalculateFee = async () => {
    if (!validateForm()) return;
    setIsSubmitting(true);
    setPriceDetails(null);
    try {
      if (!selectedLatLng) {
        setAddressNotFoundModalOpen(true);
        throw new Error('Konum seçilmedi.');
      }
      const pointID =
        selectedStore?.id || tokenService.getUser()?.firstResponsibleOffice?.id;
      const data = {
        pointID,
        receiver: {
          address: formData.acikAdres,
          location: {
            latitude: selectedLatLng.lat,
            longitude: selectedLatLng.lng,
          },
        },
      };
      const res = await Services.calculateVigoPrice(data);
      if (res.data.status) {
        setPriceDetails(res.data.result);
        setModalStep(2);
      } else {
        throw new Error(res.data.message || 'Vigo fiyatı hesaplanamadı.');
      }
    } catch (err) {
      setFormErrors({ api: err.message });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCalculateCargoFee = () => {
    if (!validateForm()) return;
    if (cargoPackages.length === 0) {
      alert('Lütfen en az bir paket ekleyin.');
      return;
    }
    // FİYAT HESAPLAMA SATIRI GÜNCELLENDİ
    const price = cargoPackages.length * 100;

    const totalDesi = cargoPackages.reduce((sum, pkg) => {
      const boyutDesi =
        (parseFloat(pkg.en || 0) *
          parseFloat(pkg.boy || 0) *
          parseFloat(pkg.yukseklik || 0)) /
        3000;
      return sum + (parseFloat(pkg.agirlik) || boyutDesi);
    }, 0);
    setPriceDetails({
      price,
      desi: totalDesi.toFixed(2),
      packageCount: cargoPackages.length,
    });
    setModalStep(2);
  };

  const handleCreateRequest = async (paymentMethod) => {
    setIsSubmitting(true);
    try {
      setLastPaymentMethod(paymentMethod);
      const pointID =
        selectedStore?.id || tokenService.getUser()?.firstResponsibleOffice?.id;
      let apiResponse;
      if (formType === 'kargo') {
        let kargoPointID = null;
        try {
          // initApiData fonksiyonunda 'userData' state'ine bilgiyi zaten kaydetmiştin.
          if (userData && userData.branchID && userData.authLocations?.branch) {
            // 1. Kullanıcının mevcut branchID'sini bul
            const userBranchID = userData.branchID;

            // 2. authLocations.branch dizisinde bu ID'ye sahip objeyi bul
            const currentBranch = userData.authLocations.branch.find(
              (b) => b.branchID === userBranchID
            );

            // 3. JSON yapısına göre malkabul ID'sine güvenli bir şekilde eriş (Optional Chaining)
            // currentBranch -> mall[0] -> points -> malkabul -> id
            kargoPointID = currentBranch?.mall?.[0]?.points?.malkabul?.id;

            if (!kargoPointID) {
              console.warn(
                "Malkabul pointID'si bulunamadı. Fallback kullanılacak."
              );
            }
          }
        } catch (e) {
          console.error(
            "Kargo için malkabul pointID'si alınırken hata oluştu:",
            e
          );
        }
        const cargoPayload = {
          pointID,
          senderName: formData.gondericiAd,
          senderLastname: formData.gondericiSoyad,
          senderPhone: formData.telefon,
          senderEmail: formData.email,
          senderAddressCity: formData.gondericiCity,
          senderAddressTown: formData.gondericiTown,
          senderAddressDetails: formData.gondericiAcikAdres,
          receiverName: formData.aliciAd,
          receiverLastname: formData.aliciSoyad,
          receiverAddressTown: formData.district,
          receiverAddressCity: formData.city,
          receiverAddressNeighbour: formData.town,
          receiverAddressDetails: formData.acikAdres,
          receiverPhone: formData.aliciTelefon,
          receiverEmail: formData.receiverEmail,
          price: priceDetails.price,
          productType: cargoPackages[0]?.icerikKategori || 'Diğer',
          receiverZipcode: formData.receiverZipcode,
          paymentMethod,
          totalDeci: priceDetails.desi,
          partCount: cargoPackages.map((pkg) => ({
            deci: parseFloat(pkg.agirlik) || 0,
          })),
          mallID: localStorage.getItem('mallID') || '',
          branchID: localStorage.getItem('branchID') || '',
          pointID: kargoPointID,
        };
        apiResponse = await Services.createCargoistPost(cargoPayload);
      } else {
        const vigoPayload = {
          pointID,
          senderName: formData.gondericiAd,
          senderLastname: formData.gondericiSoyad,
          senderPhone: formData.telefon,
          senderEmail: formData.email,
          receiverNameLastname: formData.aliciAdSoyad,
          receiverAddressTown: formData.district,
          receiverAddressCity: formData.city,
          receiverAddressNeighbour: formData.town,
          receiverAddressDetails: formData.acikAdres,
          receiverAddressDefinition: formData.adresTarifi,
          receiverPhone: formData.aliciTelefon,
          price: priceDetails.price,
          productType: formData.icerikKategori,
          additionalNote: formData.additionalNote,
          courierType: formData.kuryeModel,
          longitude: selectedLatLng?.lng || '',
          latitude: selectedLatLng?.lat || '',
          mallID: localStorage.getItem('mallID') || '',
          branchID: localStorage.getItem('branchID') || '',
        };
        apiResponse = await Services.createVigoPost(vigoPayload);
      }
      if (apiResponse && apiResponse.data.status) {
        if (formType === 'kargo') {
          const labelInfo = apiResponse.data.result?.label?.[0];
          if (labelInfo) {
            setCargoLabelData(labelInfo);
          }
        }
        const requestNo =
          formType === 'kargo'
            ? apiResponse.data.result?.barcode
            : apiResponse.data.result?.orders?.[0]?.orderNumber ||
              apiResponse.data.result?.orderIds?.[0];
        setSuccessData({
          requestNo,
          quantity: formType === 'kargo' ? cargoPackages.length : 1,
          date: new Date().toLocaleString('tr-TR'),
          source: formType === 'kargo' ? 'Kargoist' : 'Vigo',
          category: formData.icerikKategori,
          price: priceDetails.price,
          desi: priceDetails.desi,
        });
        setPaymentModalOpen(false);
        setModalStep(3);
        fetchRequests();
      } else {
        throw new Error(apiResponse.data.message || 'Gönderi oluşturulamadı.');
      }
    } catch (err) {
      setFormErrors({
        api: err.message || 'Talep oluşturulurken bir sunucu hatası oluştu.',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleMapLocationSelect = (latLng) => {
    setSelectedLatLng(latLng);
    setMapModalOpen(false);
  };

  const handleCurrentPackageChange = (event) => {
    const { name, value } = event.target;
    setCurrentPackage((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddPackage = () => {
    if (!currentPackage.icerikKategori || !currentPackage.agirlik) {
      alert('Paket içeriği ve ağırlık/desi alanları zorunludur.');
      return;
    }
    setCargoPackages([...cargoPackages, currentPackage]);
    setCurrentPackage({
      icerikKategori: '',
      agirlik: '',
      en: '',
      boy: '',
      yukseklik: '',
    });
  };

  const handleRemovePackage = (indexToRemove) => {
    setCargoPackages(
      cargoPackages.filter((_, index) => index !== indexToRemove)
    );
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const sortedRequests = [...filteredRequests].sort((a, b) => {
    if (a[orderBy] < b[orderBy]) return order === 'asc' ? -1 : 1;
    if (a[orderBy] > b[orderBy]) return order === 'asc' ? 1 : -1;
    return 0;
  });

  const handleFilterChange = (event) => {
    const { name, value } = event.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    let result = [...requests];
    const searchTerm = filters.searchText.toLowerCase();
    result = result.filter((req) => {
      if (
        searchTerm &&
        !String(req.requestNo).toLowerCase().includes(searchTerm)
      )
        return false;
      if (filters.source && req.source !== filters.source) return false;
      if (filters.senderType && req.senderType !== filters.senderType)
        return false;
      if (filters.type && req.type !== filters.type) return false;
      return true;
    });
    setFilteredRequests(result);
  }, [filters, requests]);

  const clearFilters = () => {
    setFilters({ searchText: '', source: '', senderType: '', type: '' });
    setFilterModal(false);
  };

  const handleOpenFilterModal = () => setFilterModal(true);

  const handleCloseFilterModal = () => setFilterModal(false);

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePayment = () => {
    if (!validateForm()) return;
    setPaymentModalOpen(true);
  };

  const handleCashOrPosPayment = async (type) => {
    setPendingPaymentType(type);
    setCashPosModalOpen(true);
  };

  const handleConfirmCashPosPayment = async () => {
    setCashPosModalOpen(false);
    setIsSubmitting(true);

    let paymentMethod = '';
    if (pendingPaymentType === 'cash') {
      paymentMethod = 'cash-on-delivery';
    } else if (pendingPaymentType === 'credit-card') {
      paymentMethod = 'credit-card-on-delivery';
    } else if (pendingPaymentType === 'current') {
      paymentMethod = 'current';
    }
    if (paymentMethod) {
      await handleCreateRequest(paymentMethod);
    }

    setIsSubmitting(false);
  };

  function generateConversationID(formType) {
    const prefix = formType === 'kurye' ? 'MLVG-' : 'MLKIST-';
    const uniquePartLength = 20 - prefix.length;
    const uniquePart = (
      Date.now().toString(36) + Math.random().toString(36).substr(2, 9)
    ).substr(0, uniquePartLength);
    return `${prefix}${uniquePart}`;
  }

  const handleProceedToPayment = () => {
    if (validatePaymentForm()) {
      setConversationID(generateConversationID(formType));
    }
  };

  const handleCardNumberChange = (e) => {
    const rawValue = e.target.value
      .replace(/\s+/g, '')
      .replace(/[^0-9]/g, '')
      .slice(0, 16);
    const formatted = rawValue.replace(/(\d{4})/g, '$1 ').trim();
    setCardNumber(formatted);
  };

  const handleExpiryDateChange = (e) => {
    let rawValue = e.target.value.replace(/[^0-9]/g, '').slice(0, 4);
    if (rawValue.length > 2) {
      rawValue = `${rawValue.slice(0, 2)}/${rawValue.slice(2)}`;
    }
    setExpiredDate(rawValue);
  };

  const handleCvvChange = (e) => {
    setCvv(e.target.value.replace(/[^0-9]/g, '').slice(0, 3));
  };

  const validatePaymentForm = () => {
    const errors = {};
    if (!cardName.trim()) errors.cardName = 'İsim zorunludur.';
    if (cardNumber.replace(/\s/g, '').length < 16)
      errors.cardNumber = 'Geçersiz kart numarası.';
    if (!/^\d{2}\/\d{2}$/.test(expiredDate))
      errors.expiredDate = 'AA/YY formatında girin.';
    if (cvv.length < 3) errors.cvv = '3 haneli CVV girin.';
    setPaymentFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const formTitle =
    formType === 'kargo' ? 'Kargo Talebi Oluşturun' : 'Kurye Talebi Oluşturun';
  const firmOptions = formType === 'kargo' ? kargoFirms : kuryeFirms;
  const columns = [
    { id: 'requester', label: 'TALEP EDEN KİŞİ' },
    { id: 'type', label: 'TALEP TÜRÜ' },
    { id: 'source', label: 'TALEP FİRMASI' },
    { id: 'requestNo', label: 'TALEP NO' },
    { id: 'phone', label: 'ALICI TEL NO' },
    { id: 'senderType', label: 'GÖNDERİ TİPİ' },
    { id: 'category', label: 'ÜRÜN KATEGORİSİ' },
    { id: 'date', label: 'OLUŞTURMA TARİHİ' },
    { id: 'quantity', label: 'ADET' },
    { id: 'status', label: 'DURUMU' },
    { id: 'state', label: 'STATÜ' },
    { id: 'actions', label: '', align: 'center' },
  ];

  function getStatusBadgeStyle(status) {
    if (status === 'Aktif')
      return { borderColor: '#BBF7D0', textColor: '#15803d', bg: '#F0FDF4' };
    if (status === 'Teslim Edildi')
      return {
        borderColor: '#BBF7D0',
        textColor: '#15803d',
        bg: '#F0FDF4',
        minWidth: '90px',
      };
    if (status === 'İptal')
      return {
        borderColor: 'rgba(255, 59, 48, 0.3)',
        textColor: '#B71C1C',
        bg: 'rgba(255, 59, 48, 0.08)',
      };
    return { borderColor: '#E0E0E0', textColor: '#333', bg: '#fff' };
  }

  const StatusBadge = ({ status }) => {
    const { borderColor, textColor, bg, minWidth } =
      getStatusBadgeStyle(status);
    return (
      <Box
        sx={{
          minWidth,
          width: 'fit-content',
          px: 1,
          py: 0.25,
          borderRadius: '16px',
          border: `1px solid ${borderColor}`,
          color: textColor,
          background: bg,
          fontWeight: 500,
          fontSize: 12,
          textAlign: 'center',
        }}
      >
        {status}
      </Box>
    );
  };

  const handleExportSuccessPDF = () => {
    const logoBase64 =
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGwAAABMCAYAAACIylL7AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAABLgSURBVHgB7VsJeBVFnv9Xdb9+eQmHkIOg6ATJkEOXQdEBPkVeCIf3MRh29FvWE11QUdTRFXRDPHbXCzHhEC90ddAh6ujILMhwPAiKF4oKL4ABYz4Gw8tFQvLO7qr5VYeEhCEcKppg/77vpburq6qr6l/1v0PkwIEDBw4cOHDgwIEDBw4cOHDgwIEDBw4cOHDgwIEDB50EjH4m5Ofn8z9+nNiNQtTjcHWF7t478ZxdewsKCgQdIdK8C+PiAwnC758QpeMIOv1MWFySfK7B5CSps1FSktFhRSYlE9GSP61JvQtP5XSEiNPDE2VqU7U3ZfW7Pl+OSccJNPqJkZ2XbySnXjmWEbtJEhtEkmI45sGD/hhLwbWnZKw/Ixk8QT9/fW3tUutw38jyFg5jjOaDf2Q2aTWbq3f8dScdJ/gZWKJkad7ZPeMpFnfYmlr8/bjcsu+xFsQdU7rq1s8O1SZ9aGEPvRt/FRO7BBvC4ky+HjRjt5b7pu2h4wDtWKLXm68H4lOShOBxZlOsqaxkatXBGuXlLda21tckRjnF8/DesN93TyUdMZjk+gIpdBHH60MN/vXT6gZ6n03kcaJby7Oqo2oOz5v1hz11rgzQeDQee0tGM08dvWDijhU31x+s5zRvfpzB2RTc5qgOcCpDUtA38YGTgnScoB3BAu6UNBkR/8lJnqob/Ks071P5B9uZm2srMyTTbmOWzJQ8fiOKptFRwE2xqylGE0S88UZ29sznpJZ4G8X4eTLOmJ+XN+HN4mKy2d764jtDA3NnT9dI74/HATg1OYaMTsHGetznK2gvl6DEGCXJF0iSN+OpG84n3rMlguTqo+H7Xu9qfZfuH6ZL60zIVn6oulinxgix1WWrbtvRssmONdoRzBLiBE5sGL58Gj5/skfXXkPxh+1aYGFoLTuXNPnveIrHz8j2zu3m993SSEcI6BEDwK68+MbGYApxD/HTUOyFrFpSVZXdjk1393g2h8PRuRjTw1A/EtB6UkDv+zFerWxbb/CaE3pEdPmg4rjqGf1/jdVewjm/UZ4YGER+mn0EQ6M9tLGfJo0HBLERBCF6qLoYU1gn8Xnm6Gdv37KCvqKfAO12EGcsHsqABztLgP1gV/PRBzbIXpMSj4U9F6wmbl8PmpbAXHSMsGHJzcGYGXlFSFqKR7WC/aUwb8oePqt3Sx1lIkS4Kx/EOr25REZJinmwAYaTlFdiZWdkjiocq+od6ltKJEQ0/Q60V0qRC/09Ly02saOfZbFJ0tLmiWjs5EFj706gnwDtThizWLyUMh7M/1sszMmY6JnpIwqTD5BlqXg/BjMvxw5LQh1XJBRWJ61OvVSL8voHSamMaX25kB6NmyEKunZ8lbu7no7CjmqLbb67qweOmv+YRtZgfHsAfheLONc6vCpS7xet6zPKxcS1Nk9iIJZgf5Kk7eEkrkOJ2kyJxPi9r61JqgAxtnbEvgKsz4WMxDXqJX7rGkOR/J3r76ylToR2Ow4HK44xGYf5fIVFKcPEhkLgDGhXh7OLcTlBMrkOdXaRMnmY3lO9S7+g0F28LmUSl/w5ZornQfyFpqUtNA3xakZJkpd+ALatmvwx4/TfWMgIKVbM6Z50b2G/TO/8NI3kXeAKPfYN8DMp5IucixnUzLIV0JTO0zjdl+2d1+dg/YOtYzNYj0g1N2LV3KLZnY1YCu1ZInd5pM0W+S4swP9j9n01wXJb3iuWQUxcAcFeIQVfB5bRBCrrUnKbPRohrRfaXA5CgaWytditxXiuAWEvhGx88lcjFvSlH4Km6NsY8Eu4M8Gy+hkaKyRdXANu4MU3OBa7VApWhFndhHFl2qdNyo9RHpCKmzB2lcXlY/Y82mDA2PkpktMDGLNiqWHI2FcbItES6oRoRzAhYvGkvA5SVOmSlmFjRiDXJubl5dmKVrUrSbGk0/HbJISuJhQDQQzJpb27Pd30Bs2S01Ktqiu2rLzldv/KqdNhCV2FVx9AxU7z6NFL6AfAjx0PnjoLRFC2GPYUuwKLOxO3cUorBBEXcGV6MZ6j5DDmshaTuoFL+TjuQ2jj4owmVupJlyltsKVf3Yr9Xm0qau50m6nFXu6Mp0uhddDKttpUW9XN1q8kNZi2HJObcJoGfV45IoOo2G9Jdj4mpHFpfRImozyeTBMLqHMp7BOmFARctqh7sJhUEHIg/EpQDsAgGQOrpTT6gUi1TttRyf3zcapOxViTWspBrKXYaGDlrADlqXgP25C9wAJ9t0V/VbnbFWVDMLM8zEkDKR+upE01kLhrB45KPAssfDIpUdDc0ayv/zZtI3VStJ6wzcpNxUSyuheM703wVO0EG1mLKppL18YP9D6hFmc4FsKUuntJue+6sGze1TiMvNVrMUjJldFFj4NYb2PyL2EF5qP4bCyUjgU16AdC+QXNJustLP5bLWU4ZTuxif4Xdzfgcdi+4tehRC1Rzt+y39bUMKk9BRb9SXMD9muus2kZI3qdrjM+Xbmw7GKSb/PvUl6jToxWggWrmnDP7AUVJHZvWFIQBFdZD+OwBgqGl+sJI3H4BsMWWl66fPImuxGjevxc0LVt4Z49evYpMY39BSf0RpgwX2PBprCwORSKzNOo3EQ/Eso+mtrQq3dYqd9KPlWbjN9tcf1CmCJXN8sq2shc0YdabUNop34oLYJ4ATbY59h0GjjFpdytrca1mU1LuYWCsRs6u3e/lWA9jGrIKWnbEti9zV6EGNuARdiJBU+37RmiFCHondbW0tpLynFhKc8CHoU+FoQ5Azv4JbKa/oAFW+Z//w6o0rze7vZHhPKCgADK9nqeE2/CKfvXfa9qhcnm+N/7Zxm0deUtyzAfZUA3z0+y3kpZwV0jWPecFHd9A3Vy7D9hmluzJ6AKhbRtqq1r11YwIb8AAU8CO7kYS14Nn9GGljaM6XvUjsYJbFafGQ1Wwh9G7qft/ItSptExCOX0tQIrhBAvc7LGYwynoCiM39vYeX/tqE3IjF8MHlq8f2xKOZErTIu980/urk6IVoIZIl4HK0tU96aM7W4uLYaeoS3CpKBoUQII926DLcybgbI6sBcoE1p39cyE2IY6yuYZnz1m7mDFIjNGPX2dYDTS1uTYjxscCLh79tA0Pgqn5lJsNgOb50Nhyfn+kYFAR21s2Wua0zHaFfYciMFEoafLRtbsoi6A/aqtjOkITMGOItPgRqylPGaUluixDHgHoLoL9m5VG58h1j8IooEVyjjb0y+1xWCf41ByEVnybMl0xLWU50FWoHI/VO2pPCHF6+hHgWW6R0HGPoBVB2eQlXBGP7LFN/VT8h263RbftPLMnMKHOePJjKxX/L6pvsO16SxoJZgZFUF4MV5G/OjPYe5q9dCXLS2KZI6eOwNssqdJ/MBY1DooITOlJj4M7CLuzwsEst9PvJ+E9glY1EkwoKtBqPd1S1ZaGhvFmNju9/sZlyOWo6+9kosPywWZWYwWw+CFSi4/8I0Ei/LREQFjTZa2vajAKuq7GR/QESJV1ry/myfNpKj7I+pCOCYBTBVVjjYmxhnfpoaPpdaF8M8JLfdm5KTIzvUTQkfVAWxPKp5w2Ai2AwcOfin42dLc2uK03KIpluRnM269UXpOzdLvG4b5JeBnS3NrC0R3oZDI8VJom7xr6D2fKvoJkHHOC925O/ikMm5geM+Gs9p/pO20uOD/wZyoOrBdVm7RPUyyswRnf9uy4pbn6EcGp18wNFc4AS60C2Cu5JDtpD7ydrDfLu+g3ZmwOy8hYWXQMUCnOGFHiyE3LXBFtzedHCNDBSNrwlZVRbmvIHywukpjjVUnn8E05pImNWoU3aPsMPUuSPF7PLKpQB0v2DVlbdtlnv9UmjCNfiYTYREzy1qSkYZcvCA+2CjgCLdgq8OhTUZP5RgXISOqfJxwl73EBX2Eo3DQHI9BObMzwporWY3FRYEyv6+gXS6M3RcZ6QiB8LCI7Cg/ICOtyxEMUe3k0PbYHQjbqXyT7hDCIY+WUpI9fNaD/jYxrOzsxYaVUnkp1bCrdUZZMN5VYCXKpBHLzJ37acyiJ9zuuloRM8Yxifg0c6uQSqVKKBK6dS2L8avgIe6NKLVJulYxMOeZ6fru3qXBUNWkfQlIKkcnRQrrEY17mrQEuQpFD8AldA6IdR7sUxVDXNE6HkS0hS6mxiQfrAnpUWORMqkyy1uYX+qbaic6ZY2aMwab5x6ETU5Uzx7dE8jOLXyevkstbjGPuhRLVJFhPapBdsi7pb3F5SeYIKIA8gbpMea3TcyRfXffyDW+EPLxMsia3mp1MVlc5SAmxTiXLvpRxG0goIlwjBzENelR7YTOrgMBi8DyEsHa1sGgL212EodOJJXbJa39ippUkQrmQZ/7ZS6Tv8bYfqticvYzPDsgxB1Sk0uZYAiUwnnGZAU8QAGE+DU4Mu2UBYSk/gXjfAeEhj+WdqDvDfiuLpiWXuep2++Roi4Et2n+DgQYi8VcHrOit2333Vk26Lyi/jEXexYLNU7Euc5HtUXqlOA8qVzJbljdjzD5R6U0K4jrQ7GQ9x7qGwjGXm4noUp535ZVt/5ZlSk2pVndXf7iCdE078JnDIou07RYKeohDifvCApzfRMZB3UcZ65LTken07D4MPLFMyEz/GgLm0sf8WJyT3eg2bEg2RiMFcSnP8YaxV2KvSZjHokUTcroHoh+t6+/LkUwRK0vxEI2YHJvbh9Zv0O5sL5cW/1tZk7SXxhnZ2qM5UBmvSGqzQxGGkJCcFRLMa909dR9Cz/Xo+kQXZI6ThNnLKS82sAVONHvb18+OaCytlpeK+cxNsSeZqLilHNrb/mqjtPAcayvwMBPQX0fKDqnrUwqK7m+NRsNJ7yx+fCyTM3DBsI3u9EHvy0qNG5p01+XYYnKaYzpZGAHVgkpS/fbagVCcG2jihVgvr20YJ8EpmvZ6g2c0xWIo287mu9IKZ7HXzir6feGZZVkjZ7zUPa4uen0PcEEnaWuOImfhkNmhxGBxmBjMbgCxirO4BpbBj/nK1mjC4ep9PO29boMweatSYm3QznY14jNtdMI4Vzei8kqArqjUcuDqLKdNKR0PwQzjyrG1cc6fQmc1pPwe9MOCUm6X8ZkcZb36dPpe0DQvuAuo9DO9dPCHdWrWHdfHbf4RTi1RRj4d6DM73AyX4ujpIuGDFnQmqjbZQimwjqYdC0Wshdj2ilt31kapXPJXCBoYOvfq6ulEM0sitEAjWv97eUilS0kDDpMvrzKGdmyaurysDAnQ0VXefoq/3Kw4HQ9fQ9AKSm3r5INUP+1c6i6iNCX+Sv75EPzuYokn43Gadh6/1bXq64lv7KLGc6C1mMBkjH7YdnZ+Xb+SV/YRVCTL4fm5WJKa/QXRJsijWv2tUhB+Y0DvU8mDlFJRIypNII+R/IpZXdtPTewHJS2o9PYJCfT94C0hJ3fiHHkuplSeg4DqO+lvsmbLE0stL8r2cA4k3taXncqpQMy50rw7kHZuXPbuKZk1CLr9a0rb19tauxZXcgxqDlFnpgSyzpx3noKRifAjBoPam6qbJKLVAvFXrJy5z6N25tVnjzncbuDnGJgNSoNQm3SuoN9P937XD+XHn4CrGiNJLGdlzBF8GvJTlxtibvZJ6EyM3fODoz3V5bUrxk4uvBUSNCdW1dNW3Vgn7B/V6EvlbIwjmu0KHPU3EL4TL+BmYZwHvsNs6zVpjQ+0Hnsv/CtnRheGRcihM35H0KlLzD6stZI3dvSXyfTEuUwUG2YbJ+v08iJq/9WWS11q5TCfAYmcR/smHulSp2DbMC1BM+P1UIVbmnEWGwWCVcIN0Mh+fth6gixsgq8GtO2e7RtQB8Rgc7BWyOks9/g+TJGPE42Jw5Bo5bPRrXwu20HxYk9JpmYDlZ8I9jX1SiZhWIQjO3FWPZAPbSzxPy+KbtPyymaITX2jcrUgs90JurbzhWI3S0mpzWw/mNBoWjBHkB5N4mdgNfKAwJ5yop2D98eouXN3+0czl9pPsg0o+hg71yCRyNW49fqvmzp1Eh23uK3zfrdX8IbMBhE6EUW+5YZsc9L35v2Xdt2DU2isYebHrEMkUym1R0eiz1S6COxFjmt9EoO1FJV4g0aF8E9IfH1TndVLIv3zhNR6sd1rT+LqYg5x7eryravbO9CshIaF/Gg5wvJrFPJdEc4iS9UObPYo8TFcyR4RXNNJjevpi/ShxbOMLrTi6DEAIu0niBZDemxMj2ql29I7hXKaqh7iJmR16TkaeACYAPy77hutvNT2kQvOkV45VggK3fOG7jUC2EujmlUalgsGer+/4DIOTg3n8WEGF/mm9rl/ve5Szp/jwLXc65f75aQWRolgFhKUVHp5G91RWIpHLcEA9t7EiylHJJ9KO5PgTlQDyGvMoCW1XmMF6iL4rhliQr9hs/ydIs34pnuMtTB2tsgI7q7PthRKMaBAwcOHDhw4MCBAwcOHDhw4MCBAwcOHDhw4MCBAwcOHBwF/gFfKIqEBJwp/wAAAABJRU5ErkJggg==';

    const docDefinition = {
      content: [
        {
          image: logoBase64,
          width: 70,
          alignment: 'left',
          margin: [0, 0, 0, 20],
        },
        {
          text: 'Gönderi Başarı Özeti',
          style: 'header',
          alignment: 'center',
          margin: [0, 0, 0, 20],
        },
        { text: 'Genel Bilgiler', style: 'subheader' },
        {
          style: 'tableExample',
          table: {
            widths: ['*', '*'],
            body: [
              ['Gönderi Kodu:', { text: successData?.requestNo, bold: true }],
              ['Firma:', successData?.source],
              ['Oluşturma Tarihi:', successData?.date],
            ],
          },
          layout: 'noBorders',
        },
        { text: 'Ödeme Detayları', style: 'subheader' },
        {
          style: 'tableExample',
          table: {
            widths: ['*', '*'],
            body: [
              ['Ödeme Yöntemi:', getPaymentMethodText(lastPaymentMethod)],
              ...(lastPaymentMethod === 'online-payment'
                ? [['Kart Numarası:', maskCardNumber(cardNumber)]]
                : []),
              [
                'Toplam Tutar:',
                {
                  text: `${successData?.price?.toFixed(2)} TL`,
                  bold: true,
                  color: 'green',
                },
              ],
            ],
          },
          layout: 'noBorders',
        },
        { text: 'Adres Bilgileri', style: 'subheader' },
        {
          columns: [
            {
              width: '*',
              stack: [
                { text: 'Gönderici', bold: true, margin: [0, 0, 0, 5] },
                `${formData.gondericiAd} ${formData.gondericiSoyad}`,
                formType === 'kargo'
                  ? `${formData.gondericiAcikAdres}, ${formData.gondericiTown}/${formData.gondericiCity}`
                  : selectedStore?.name || 'Mağaza Adresi',
              ],
            },
            {
              width: '*',
              stack: [
                { text: 'Alıcı', bold: true, margin: [0, 0, 0, 5] },
                formType === 'kargo'
                  ? `${formData.aliciAd} ${formData.aliciSoyad}`
                  : formData.aliciAdSoyad,
                `${formData.acikAdres}, ${formData.town}/${formData.district}, ${formData.city}`,
              ],
            },
          ],
          columnGap: 20,
        },
        ...(formType === 'kargo'
          ? [
              { text: 'Paket Detayları', style: 'subheader' },
              {
                style: 'tableExample',
                table: {
                  headerRows: 1,
                  widths: ['auto', '*', 'auto', '*'],
                  body: [
                    [
                      { text: '#', style: 'tableHeader' },
                      { text: 'İçerik', style: 'tableHeader' },
                      { text: 'Desi', style: 'tableHeader' },
                      { text: 'Boyutlar (cm)', style: 'tableHeader' },
                    ],
                    ...cargoPackages.map((pkg, index) => [
                      (index + 1).toString(),
                      pkg.icerikKategori,
                      pkg.agirlik,
                      pkg.en && pkg.boy && pkg.yukseklik
                        ? `${pkg.en} x ${pkg.boy} x ${pkg.yukseklik}`
                        : 'Belirtilmedi',
                    ]),
                  ],
                },
              },
            ]
          : []),
      ],
      styles: {
        header: {
          fontSize: 18,
          bold: true,
        },
        subheader: {
          fontSize: 14,
          bold: true,
          margin: [0, 15, 0, 5],
        },
        tableExample: {
          margin: [0, 5, 0, 15],
        },
        tableHeader: {
          bold: true,
          fontSize: 12,
          color: 'black',
        },
      },
    };
    pdfMake.createPdf(docDefinition).open();
  };
  const handleDownloadPdf = () => {
    if (!cargoLabelData || !cargoLabelData.label) return;

    try {
      const byteCharacters = atob(cargoLabelData.label);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${cargoLabelData.consignmentNumber}.pdf`);
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('PDF indirme hatası:', error);
      alert('PDF etiketi indirilirken bir hata oluştu.');
    }
  };

  const renderSelectType = () => (
    <Box p={3}>
      <Typography variant="h6" mb={2}>
        Kurye - Kargo
      </Typography>
      <Stack spacing={2}>
        {/* 
        <Button
          fullWidth
          variant="contained"
          startIcon={<MopedIcon />}
          sx={{
            justifyContent: "flex-start",
            background: "rgba(32, 101, 209, 1)",
            color: "#fff",
            py: 2,
            px: 3,
            borderRadius: 2,
          }}
          onClick={() => {
            setFormType("kurye");
            setModalStep(1);
          }}
        >
          Kurye Talebi Oluştur
        </Button>
        */}
        <Button
          fullWidth
          variant="contained"
          startIcon={<LocalShippingIcon />}
          sx={{
            justifyContent: 'flex-start',
            background: 'rgba(32, 101, 209, 1)',
            color: '#fff',
            py: 2,
            px: 3,
            borderRadius: 2,
          }}
          onClick={() => {
            setFormType('kargo');
            setModalStep(1);
          }}
        >
          Kargo Talebi Oluştur
        </Button>
      </Stack>
    </Box>
  );

  const renderForm = () => (
    <Box p={3} sx={{ minWidth: 600 }}>
      {formErrors.api && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {formErrors.api}
        </Alert>
      )}
      <Typography variant="h6" mb={2}>
        {formTitle}
      </Typography>
      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel>Firma</InputLabel>
        <Select value={firmOptions[0].value} label="Firma" disabled>
          <MenuItem value={firmOptions[0].value}>
            {firmOptions[0].label}
          </MenuItem>
        </Select>
      </FormControl>
      <Typography variant="subtitle2" mt={2} mb={1}>
        Gönderici Bilgileri
      </Typography>
      <Stack direction="row" spacing={2} mb={2}>
        <TextField
          label="Gönderici Ad"
          name="gondericiAd"
          value={formData.gondericiAd}
          onChange={handleFormChange}
          error={!!formErrors.gondericiAd}
          helperText={formErrors.gondericiAd}
          fullWidth
        />
        <TextField
          label="Gönderici Soyad"
          name="gondericiSoyad"
          value={formData.gondericiSoyad}
          onChange={handleFormChange}
          error={!!formErrors.gondericiSoyad}
          helperText={formErrors.gondericiSoyad}
          fullWidth
        />
      </Stack>
      <Stack direction="row" spacing={2} mb={2}>
        <TextField
          label="Telefon No"
          name="telefon"
          value={formData.telefon}
          onChange={handleFormChange}
          error={!!formErrors.telefon}
          helperText={formErrors.telefon}
          fullWidth
        />
        <TextField
          label="E-mail Adresi"
          name="email"
          value={formData.email}
          onChange={handleFormChange}
          error={!!formErrors.email}
          helperText={formErrors.email}
          fullWidth
        />
      </Stack>
      {formType === 'kargo' && (
        <>
          <Stack direction="row" spacing={2} mb={2}>
            <TextField
              label="TCKN"
              name="tckn"
              value={formData.tckn}
              onChange={handleFormChange}
              error={!!formErrors.tckn}
              helperText={formErrors.tckn}
              fullWidth
              inputProps={{ maxLength: 11 }}
            />
            <FormControl fullWidth>
              <InputLabel>Gönderi Tipi</InputLabel>
              <Select
                name="bireyselKurumsal"
                value={formData.bireyselKurumsal}
                label="Gönderi Tipi"
                onChange={handleFormChange}
              >
                <MenuItem value="Bireysel">Bireysel</MenuItem>
                <MenuItem value="Kurumsal">Kurumsal</MenuItem>
              </Select>
            </FormControl>
          </Stack>
          <Stack direction="row" spacing={2} mb={2}>
            <FormControl fullWidth>
              <InputLabel>Gönderici İl</InputLabel>
              <Select
                name="gondericiCity"
                value={formData.gondericiCity}
                label="Gönderici İl"
                onChange={handleFormChange}
              >
                {cities.map((city) => (
                  <MenuItem key={city.code} value={city.name}>
                    {city.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel>Gönderici İlçe</InputLabel>
              <Select
                name="gondericiTown"
                value={formData.gondericiTown}
                label="Gönderici İlçe"
                onChange={handleFormChange}
                disabled={!formData.gondericiCity}
              >
                {gondericiTowns.map((town) => (
                  <MenuItem key={town.code} value={town.name}>
                    {town.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
          <TextField
            label="Gönderici Açık Adres"
            name="gondericiAcikAdres"
            value={formData.gondericiAcikAdres}
            onChange={handleFormChange}
            multiline
            rows={2}
            fullWidth
            sx={{ mb: 2 }}
          />
        </>
      )}
      <Typography variant="subtitle2" mt={2} mb={1}>
        Gönderi Bilgileri
      </Typography>
      <Stack direction="row" spacing={2} mb={2}>
        <FormControl fullWidth error={!!formErrors.icerikKategori}>
          <InputLabel>İçerik Kategorisi</InputLabel>
          <Select
            name="icerikKategori"
            value={formData.icerikKategori}
            label="İçerik Kategorisi"
            onChange={handleFormChange}
          >
            {categories.map((cat) => (
              <MenuItem key={cat} value={cat}>
                {cat}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          label="Paket Adedi"
          name="paketAdedi"
          type="number"
          inputProps={{ min: 1 }}
          value={formData.paketAdedi}
          onChange={handleFormChange}
          error={!!formErrors.paketAdedi}
          helperText={formErrors.paketAdedi}
          fullWidth
          disabled={formType === 'kargo'}
        />
      </Stack>
      {formType === 'kargo' && (
        <>
          <Box p={2} border="1px solid #e0e0e0" borderRadius={1} mb={2}>
            <Typography variant="subtitle1" fontWeight={500} mb={2}>
              Paket Ekle
            </Typography>
            <Stack spacing={2}>
              <FormControl fullWidth>
                <InputLabel>Paket İçeriği</InputLabel>
                <Select
                  name="icerikKategori"
                  value={currentPackage.icerikKategori}
                  onChange={handleCurrentPackageChange}
                  label="Paket İçeriği"
                >
                  {categories.map((cat) => (
                    <MenuItem key={cat} value={cat}>
                      {cat}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                label="Ağırlık/Desi"
                name="agirlik"
                value={currentPackage.agirlik}
                onChange={handleCurrentPackageChange}
                fullWidth
              />
              <Stack direction="row" spacing={1}>
                <TextField
                  name="en"
                  label="En(cm)"
                  value={currentPackage.en}
                  onChange={handleCurrentPackageChange}
                />
                <TextField
                  name="boy"
                  label="Boy(cm)"
                  value={currentPackage.boy}
                  onChange={handleCurrentPackageChange}
                />
                <TextField
                  name="yukseklik"
                  label="Yükseklik(cm)"
                  value={currentPackage.yukseklik}
                  onChange={handleCurrentPackageChange}
                />
              </Stack>
              <Button variant="outlined" onClick={handleAddPackage}>
                Paketi Ekle
              </Button>
            </Stack>
          </Box>
          {cargoPackages.length > 0 && (
            <Box mb={2}>
              <Typography variant="subtitle2">
                Eklenen Paketler ({cargoPackages.length})
              </Typography>
              <Stack spacing={1} mt={1}>
                {cargoPackages.map((pkg, index) => (
                  <Box
                    key={index}
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    p={1}
                    bgcolor="#f9f9f9"
                    borderRadius={1}
                  >
                    <Typography variant="body2">
                      {pkg.icerikKategori} - {pkg.agirlik} Desi |{' '}
                      {pkg.en && pkg.boy && pkg.yukseklik
                        ? ` (En:${pkg.en} x Boy:${pkg.boy} x Yükseklik:${pkg.yukseklik} cm)`
                        : ''}
                    </Typography>
                    <IconButton
                      size="small"
                      onClick={() => handleRemovePackage(index)}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </Box>
                ))}
              </Stack>
            </Box>
          )}
        </>
      )}
      {formType === 'kurye' && (
        <FormControl fullWidth error={!!formErrors.kuryeModel} sx={{ mb: 2 }}>
          <InputLabel>Kurye Modeli</InputLabel>
          <Select
            name="kuryeModel"
            value={formData.kuryeModel}
            label="Kurye Modeli"
            onChange={handleFormChange}
          >
            <MenuItem value="MotorCourier">Moto Kurye</MenuItem>
          </Select>
        </FormControl>
      )}
      <Typography variant="subtitle2" mt={2} mb={1}>
        Alıcı Bilgileri
      </Typography>
      <Stack direction="row" spacing={2} mb={2}>
        <FormControl fullWidth error={!!formErrors.city}>
          <InputLabel>Alıcı İl</InputLabel>
          <Select
            name="city"
            value={formData.city}
            label="Alıcı İl"
            onChange={handleFormChange}
          >
            {cities.map((city) => (
              <MenuItem key={city.code} value={city.name}>
                {city.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth error={!!formErrors.district}>
          <InputLabel>Alıcı İlçe</InputLabel>
          <Select
            name="district"
            value={formData.district}
            label="Alıcı İlçe"
            onChange={handleFormChange}
            disabled={!formData.city}
          >
            {towns.map((town) => (
              <MenuItem key={town.code} value={town.name}>
                {town.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>
      <Stack direction="row" spacing={2} mb={2}>
        <FormControl fullWidth error={!!formErrors.town}>
          <InputLabel>Alıcı Mahalle</InputLabel>
          <Select
            name="town"
            value={formData.town}
            label="Alıcı Mahalle"
            onChange={handleFormChange}
            disabled={!formData.district}
          >
            {districts.map((district) => (
              <MenuItem key={district.code} value={district.name}>
                {district.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>
      <Stack direction="row" spacing={2} mb={2}>
        {formType === 'kargo' ? (
          <>
            <TextField
              label="Alıcı Ad"
              name="aliciAd"
              value={formData.aliciAd}
              onChange={handleFormChange}
              error={!!formErrors.aliciAd}
              helperText={formErrors.aliciAd}
              fullWidth
            />
            <TextField
              label="Alıcı Soyad"
              name="aliciSoyad"
              value={formData.aliciSoyad}
              onChange={handleFormChange}
              error={!!formErrors.aliciSoyad}
              helperText={formErrors.aliciSoyad}
              fullWidth
            />
          </>
        ) : (
          <TextField
            label="Alıcı Ad Soyad"
            name="aliciAdSoyad"
            value={formData.aliciAdSoyad}
            onChange={handleFormChange}
            error={!!formErrors.aliciAdSoyad}
            helperText={formErrors.aliciAdSoyad}
            fullWidth
          />
        )}
      </Stack>
      <TextField
        label="Alıcı Telefon No"
        name="aliciTelefon"
        value={formData.aliciTelefon}
        onChange={handleFormChange}
        error={!!formErrors.aliciTelefon}
        helperText={formErrors.aliciTelefon}
        fullWidth
        sx={{ mb: 2 }}
      />
      <TextField
        label="Alıcı E-mail Adresi"
        name="receiverEmail"
        value={formData.receiverEmail}
        onChange={handleFormChange}
        error={!!formErrors.receiverEmail}
        helperText={formErrors.receiverEmail}
        fullWidth
      />
      {formType === 'kargo' && (
        <Stack direction="row" spacing={2} my={2}>
          <TextField
            label="Alıcı Posta Kodu"
            name="receiverZipcode"
            value={formData.receiverZipcode}
            onChange={handleFormChange}
            error={!!formErrors.receiverZipcode}
            helperText={formErrors.receiverZipcode}
            fullWidth
          />
        </Stack>
      )}
      <TextField
        label="Açık adres..."
        name="acikAdres"
        value={formData.acikAdres}
        onChange={handleFormChange}
        error={!!formErrors.acikAdres}
        helperText={formErrors.acikAdres}
        fullWidth
        multiline
        rows={3}
        sx={{ my: 2 }}
      />
      {formType === 'kurye' && (
        <>
          <TextField
            label="Adres Tarifi"
            name="adresTarifi"
            value={formData.adresTarifi}
            onChange={handleFormChange}
            fullWidth
            sx={{ mb: 2 }}
          />
          <TextField
            label="Ek Not"
            name="additionalNote"
            value={formData.additionalNote}
            onChange={handleFormChange}
            fullWidth
            sx={{ mb: 2 }}
          />
        </>
      )}
      {formType === 'kargo' ? (
        <Button
          fullWidth
          variant="contained"
          sx={{ background: 'rgba(32, 101, 209, 1)', color: '#fff', mt: 2 }}
          onClick={handleCalculateCargoFee}
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            'Kargo Ücretini Hesapla'
          )}
        </Button>
      ) : (
        <Stack direction="row" spacing={2} mt={2}>
          <Button
            fullWidth
            variant="contained"
            sx={{ background: 'rgba(32, 101, 209, 1)', color: '#fff' }}
            onClick={handleCalculateFee}
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              'Ücreti Hesapla'
            )}
          </Button>
          <Button
            fullWidth
            variant="outlined"
            onClick={() => setMapModalOpen(true)}
          >
            Haritadan Seç
          </Button>
        </Stack>
      )}
    </Box>
  );

  const renderPayment = () => {
    return (
      <Box
        p={3}
        sx={{
          minWidth: 500,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {formErrors.api && (
          <Alert severity="error" sx={{ mb: 2, width: '100%' }}>
            {formErrors.api}
          </Alert>
        )}
        <Typography variant="h6" mb={2}>
          {formTitle}
        </Typography>
        <Box
          sx={{
            background: '#F7F7F7',
            borderRadius: 2,
            p: 3,
            width: '100%',
            maxWidth: 450,
            mb: 4,
          }}
        >
          <Box sx={{ textAlign: 'center', mb: 2 }}>
            <Typography variant="subtitle2" color="#B0B0B0">
              Ödenecek Toplam Tutar
            </Typography>
            <Typography variant="h4" fontWeight={700} color="primary.main">
              {priceDetails?.price?.toFixed(2) || '0.00'} TL
            </Typography>
          </Box>

          <Divider sx={{ my: 2 }} />

          <Typography variant="subtitle2" color="#B0B0B0" mb={1}>
            Gönderi Detayları
          </Typography>
          {formType === 'kargo' ? (
            <>
              <Stack spacing={1} mb={1.5}>
                {cargoPackages.map((pkg, index) => (
                  <Box key={index} sx={{ fontSize: '0.875rem' }}>
                    <Typography variant="body2" fontWeight={500}>
                      {index + 1}. Paket: {pkg.icerikKategori}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {`Desi: ${pkg.agirlik}`}
                      {pkg.en && pkg.boy && pkg.yukseklik
                        ? ` (E:${pkg.en} x B:${pkg.boy} x Y:${pkg.yukseklik} cm)`
                        : ''}
                    </Typography>
                  </Box>
                ))}
              </Stack>
              <Stack spacing={0.5}>
                <Stack direction="row" justifyContent="space-between">
                  <Typography variant="body2">Toplam Paket:</Typography>
                  <Typography variant="body2" fontWeight={500}>
                    {priceDetails?.packageCount} Adet
                  </Typography>
                </Stack>
                <Stack direction="row" justifyContent="space-between">
                  <Typography variant="body2">Toplam Desi:</Typography>
                  <Typography variant="body2" fontWeight={500}>
                    {priceDetails?.desi} Desi
                  </Typography>
                </Stack>
              </Stack>
            </>
          ) : (
            <Stack direction="row" justifyContent="space-between">
              <Typography variant="body2">Paket Adedi:</Typography>
              <Typography variant="body2" fontWeight={500}>
                {formData.paketAdedi} Adet
              </Typography>
            </Stack>
          )}

          <Divider sx={{ my: 2 }} />

          <Typography variant="subtitle2" color="#B0B0B0" mb={1}>
            Gönderici Bilgileri
          </Typography>
          <Typography variant="body2" fontWeight={500}>
            {formData.gondericiAd} {formData.gondericiSoyad}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {formType === 'kargo'
              ? `${formData.gondericiAcikAdres}, ${formData.gondericiTown}/${formData.gondericiCity}`
              : selectedStore?.name || 'Mağaza Adresi'}
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="subtitle2" color="#B0B0B0" mb={1}>
            Alıcı Bilgileri
          </Typography>
          <Typography variant="body2" fontWeight={500}>
            {formType === 'kargo'
              ? `${formData.aliciAd} ${formData.aliciSoyad}`
              : formData.aliciAdSoyad}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {`${formData.acikAdres}, ${formData.town}/${formData.district}, ${formData.city}`}
          </Typography>
        </Box>
        {formType === 'kargo' ? (
          <Box sx={{ maxWidth: '450px', width: '100%' }}>
            <Button
              fullWidth
              variant="contained"
              sx={{
                background: 'rgba(32, 101, 209, 1)',
                width: '100%',
                color: '#fff',
              }}
              onClick={handlePayment}
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                'Online Ödeme Yap'
              )}
            </Button>
            <Button
              fullWidth
              sx={{ mt: 1, width: '100%' }}
              variant="outlined"
              onClick={() => handleCashOrPosPayment('current')}
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                'Cari ile Gönderi Oluştur'
              )}
            </Button>
          </Box>
        ) : (
          <Box sx={{ maxWidth: '450px' }}>
            <Button
              fullWidth
              variant="contained"
              sx={{
                background: 'rgba(32, 101, 209, 1)',
                width: '100%',
                color: '#fff',
              }}
              onClick={handlePayment}
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                'Online Ödeme Yap'
              )}
            </Button>
            <Button
              fullWidth
              sx={{ mt: 1, width: '100%' }}
              variant="outlined"
              onClick={() => handleCashOrPosPayment('cash')}
              disabled={isSubmitting}
            >
              Nakit Ödeme
            </Button>
            <Button
              fullWidth
              sx={{ mt: 1, width: '100%' }}
              variant="outlined"
              onClick={() => handleCashOrPosPayment('credit-card')}
              disabled={isSubmitting}
            >
              Fiziki POS ile Ödeme
            </Button>
          </Box>
        )}
        <IconButton
          sx={{ position: 'absolute', left: 24, top: 24 }}
          onClick={() => setModalStep(1)}
        >
          <span style={{ fontSize: 24 }}>&larr;</span>
        </IconButton>
      </Box>
    );
  };

  const getPaymentMethodText = (method) => {
    switch (method) {
      case 'online-payment':
        return 'Online Kredi Kartı';
      case 'current':
        return 'Cari Hesap';
      case 'cash-on-delivery':
        return 'Nakit Ödeme';
      case 'credit-card-on-delivery':
        return 'Fiziki POS';
      default:
        return 'Belirtilmemiş';
    }
  };

  // Kart numarasını maskeleyen yardımcı fonksiyon
  const maskCardNumber = (fullCardNumber) => {
    if (!fullCardNumber) return '';
    const cleaned = fullCardNumber.replace(/\s/g, '');
    if (cleaned.length < 16) return 'Geçersiz Kart';
    const firstFour = cleaned.substring(0, 4);
    const lastFour = cleaned.substring(cleaned.length - 4);
    return `${firstFour} **** **** ${lastFour}`;
  };

  const renderSuccess = () => {
    return (
      <Box
        p={3}
        sx={{
          minWidth: 600,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography variant="h6" mb={2}>
          Gönderi Özeti
        </Typography>
        <Box
          sx={{
            background: '#F6F7F8',
            borderRadius: 2,
            p: 2,
            width: '100%',
            maxWidth: 700,
            mb: 3,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Box sx={{ mr: 2 }}>
            <Box
              component="img"
              src="/assets/icons/checkmark.png"
              alt="Checkmark"
            />
          </Box>
          <Typography fontWeight={500}>
            Gönderiniz Başarıyla Oluşturulmuştur.
          </Typography>
        </Box>

        <Box sx={{ width: '100%', maxWidth: 700 }}>
          {/* Gönderi ve Ödeme Bilgileri */}
          <Stack spacing={1} mb={2}>
            <Stack direction="row" justifyContent="space-between">
              <Typography variant="body2" color="text.secondary">
                Gönderi Kodu:
              </Typography>
              <Typography variant="body2" fontWeight={700}>
                {successData?.requestNo}
              </Typography>
            </Stack>
            <Stack direction="row" justifyContent="space-between">
              <Typography variant="body2" color="text.secondary">
                Firma:
              </Typography>
              <Typography variant="body2" fontWeight={500}>
                {successData?.source}
              </Typography>
            </Stack>
            <Stack direction="row" justifyContent="space-between">
              <Typography variant="body2" color="text.secondary">
                Ödeme Yöntemi:
              </Typography>
              <Typography variant="body2" fontWeight={500}>
                {getPaymentMethodText(lastPaymentMethod)}
              </Typography>
            </Stack>
            {lastPaymentMethod === 'online-payment' && (
              <Stack direction="row" justifyContent="space-between">
                <Typography variant="body2" color="text.secondary">
                  Kart Numarası:
                </Typography>
                <Typography variant="body2" fontWeight={500}>
                  {maskCardNumber(cardNumber)}
                </Typography>
              </Stack>
            )}
            <Stack direction="row" justifyContent="space-between">
              <Typography variant="body2" color="text.secondary">
                Toplam Tutar:
              </Typography>
              <Typography variant="body2" fontWeight={700} color="primary.main">
                {successData?.price?.toFixed(2)} TL
              </Typography>
            </Stack>
          </Stack>

          <Divider sx={{ my: 2 }} />

          {/* Adres Bilgileri */}
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} mb={2}>
            <Box flex={1}>
              <Typography variant="subtitle2" mb={1}>
                Gönderici Bilgileri
              </Typography>
              <Typography variant="body2" fontWeight={500}>
                {formData.gondericiAd} {formData.gondericiSoyad}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {formType === 'kargo'
                  ? `${formData.gondericiAcikAdres}, ${formData.gondericiTown}/${formData.gondericiCity}`
                  : selectedStore?.name || 'Mağaza Adresi'}
              </Typography>
            </Box>
            <Box flex={1}>
              <Typography variant="subtitle2" mb={1}>
                Alıcı Bilgileri
              </Typography>
              <Typography variant="body2" fontWeight={500}>
                {formType === 'kargo'
                  ? `${formData.aliciAd} ${formData.aliciSoyad}`
                  : formData.aliciAdSoyad}
              </Typography>
              <Typography
                variant="caption"
                color="text.secondary"
              >{`${formData.acikAdres}, ${formData.town}/${formData.district}, ${formData.city}`}</Typography>
            </Box>
          </Stack>

          {/* Sadece kargo ise paket detaylarını göster */}
          {formType === 'kargo' && (
            <>
              <Divider sx={{ my: 2 }} />
              <Typography variant="subtitle2" mb={1}>
                Paket Detayları
              </Typography>
              <Stack spacing={1.5}>
                {cargoPackages.map((pkg, index) => (
                  <Box key={index} p={1.5} bgcolor="#F6F7F8" borderRadius={1}>
                    <Typography variant="body2" fontWeight={500}>
                      {index + 1}. Paket: {pkg.icerikKategori}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {`Desi: ${pkg.agirlik}`}
                      {pkg.en && pkg.boy && pkg.yukseklik
                        ? ` (E:${pkg.en} x B:${pkg.boy} x Y:${pkg.yukseklik} cm)`
                        : ''}
                    </Typography>
                  </Box>
                ))}
              </Stack>
            </>
          )}

          {formType === 'kargo' && cargoLabelData && (
            <>
              <Button
                fullWidth
                variant="outlined"
                startIcon={<DescriptionIcon />}
                onClick={handleDownloadPdf}
                sx={{ my: 3 }}
              >
                PDF Etiketi İndir
              </Button>
              <Button
                fullWidth
                variant="outlined"
                color="secondary"
                startIcon={<DescriptionIcon />}
                onClick={handleExportSuccessPDF}
              >
                Özeti PDF Olarak Kaydet
              </Button>
            </>
          )}
        </Box>

        <Button
          fullWidth
          variant="contained"
          sx={{
            background: 'rgba(32, 101, 209, 1)',
            color: '#fff',
            mt: 2,
            maxWidth: 700,
          }}
          onClick={handleCloseModal}
        >
          Kapat
        </Button>
      </Box>
    );
  };

  return (
    <>
      <Helmet>
        <title>Kurye - Kargo</title>
      </Helmet>
      <Stack style={{ padding: '25px' }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={2}
          borderBottom="1px solid rgba(235, 235, 235, 1)"
          paddingBottom={1.5}
        >
          <Typography variant="h4" sx={{ fontSize: '16px !important' }}>
            Kurye - Kargo
          </Typography>
          <Button
            variant="contained"
            startIcon={<LocalShippingIcon />}
            onClick={handleOpenModal}
            sx={{
              backgroundColor: 'rgba(32, 101, 209, 1)',
              '&:hover': { backgroundColor: '#1565c0' },
              fontWeight: 500,
              fontSize: '14px',
            }}
          >
            Yeni Talep Oluştur
          </Button>
        </Stack>
        <Box
          sx={{
            backgroundColor: 'white',
            pt: 2,
            boxShadow: 1,
            borderRadius: 1,
            mt: 3,
          }}
        >
          <Box sx={{ px: 2 }}>
            <Typography
              variant="h5"
              gutterBottom
              mb={2}
              sx={{ fontSize: '14px !important' }}
            >
              Kargo - Kurye Talep Listesi
            </Typography>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              mb={3}
            >
              <Box
                display="flex"
                alignItems="center"
                flexGrow={1}
                maxWidth="400px"
              >
                <TextField
                  fullWidth
                  placeholder="Talep no ara..."
                  variant="outlined"
                  size="small"
                  name="searchText"
                  value={filters.searchText}
                  onChange={handleFilterChange}
                  InputProps={{
                    startAdornment: (
                      <IconButton>
                        <SearchIcon />
                      </IconButton>
                    ),
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '4px',
                      backgroundColor: '#fff',
                    },
                  }}
                />
              </Box>
              <Button
                variant="outlined"
                startIcon={<FilterAltIcon />}
                onClick={handleOpenFilterModal}
                sx={{
                  borderColor: 'rgba(32, 101, 209, 1)',
                  color: 'rgba(32, 101, 209, 1)',
                  '&:hover': { borderColor: '#1565c0' },
                }}
              >
                Filtrele
              </Button>
            </Box>
          </Box>
          <Card sx={{ overflow: 'auto' }}>
            <Table sx={{ minWidth: 1200 }}>
              <TableHead>
                <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align || 'left'}
                      sx={{ fontWeight: 'bold', fontSize: '12px' }}
                      sortDirection={orderBy === column.id ? order : false}
                    >
                      {column.id !== 'actions' ? (
                        <TableSortLabel
                          active={orderBy === column.id}
                          direction={orderBy === column.id ? order : 'asc'}
                          onClick={() => handleRequestSort(column.id)}
                        >
                          {column.label}
                        </TableSortLabel>
                      ) : (
                        column.label
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : error ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      <Alert severity="error">{error}</Alert>
                    </TableCell>
                  </TableRow>
                ) : (
                  sortedRequests
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => (
                      <TableRow key={row.id} hover>
                        {columns.map((column) => (
                          <TableCell
                            key={column.id}
                            align={column.align || 'left'}
                          >
                            {column.id === 'status' ? (
                              <StatusBadge status={row.status} />
                            ) : column.id === 'actions' ? (
                              <Stack direction="row" spacing={1}>
                                <IconButton size="small" title="Detaylar">
                                  <DescriptionIcon />
                                </IconButton>
                                <IconButton size="small" title="Düzenle">
                                  <EditIcon />
                                </IconButton>
                              </Stack>
                            ) : (
                              row[column.id]
                            )}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))
                )}
              </TableBody>
            </Table>
          </Card>
        </Box>
        <TablePagination
          rowsPerPageOptions={[10, 25, 50]}
          component="div"
          count={filteredRequests.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
        <CustomFilter
          modalType={'drawer'}
          filterModal={filterModal}
          handleCloseModal={handleCloseFilterModal}
        >
          <Stack spacing={2} p={2}>
            <FormControl fullWidth>
              <InputLabel>Talep Firması</InputLabel>
              <Select
                name="source"
                value={filters.source}
                label="Talep Firması"
                onChange={handleFilterChange}
              >
                <MenuItem value="">Tümü</MenuItem>
                <MenuItem value="Kargoist">Kargoist</MenuItem>
                <MenuItem value="Vigo">Vigo</MenuItem>
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel>Gönderi Tipi</InputLabel>
              <Select
                name="senderType"
                value={filters.senderType}
                label="Gönderi Tipi"
                onChange={handleFilterChange}
              >
                <MenuItem value="">Tümü</MenuItem>
                <MenuItem value="Bireysel">Bireysel</MenuItem>
                <MenuItem value="Kurumsal">Kurumsal</MenuItem>
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel>Talep Türü</InputLabel>
              <Select
                name="type"
                value={filters.type}
                label="Talep Türü"
                onChange={handleFilterChange}
              >
                <MenuItem value="">Tümü</MenuItem>
                <MenuItem value="Kargo">Kargo</MenuItem>
                <MenuItem value="Kurye">Kurye</MenuItem>
              </Select>
            </FormControl>
          </Stack>
          <Stack direction="row" p={2} spacing={2} justifyContent="center">
            <ClearButton onClick={clearFilters} />
            <FilterButton onClick={() => setFilterModal(false)} />
          </Stack>
        </CustomFilter>
        <Dialog
          open={modalOpen}
          onClose={handleCloseModal}
          maxWidth="md"
          fullWidth
        >
          <IconButton
            sx={{ position: 'absolute', right: 16, top: 16 }}
            onClick={handleCloseModal}
          >
            <CloseIcon />
          </IconButton>
          {modalStep === 0 && renderSelectType()}
          {modalStep === 1 && renderForm()}
          {modalStep === 2 && renderPayment()}
          {modalStep === 3 && renderSuccess()}
        </Dialog>
        <Dialog
          open={mapModalOpen}
          onClose={() => setMapModalOpen(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>Haritadan Konum Seç</DialogTitle>
          <DialogContent sx={{ height: 400 }}>
            <GoogleMapSelector
              onLocationSelect={handleMapLocationSelect}
              initialLocation={selectedLatLng}
              initialAddress={`${formData.district}, ${formData.city}`}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setMapModalOpen(false)}>Kapat</Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={addressNotFoundModalOpen}
          onClose={() => setAddressNotFoundModalOpen(false)}
        >
          <DialogTitle>Konum Bulunamadı</DialogTitle>
          <DialogContent>
            <Typography>
              Girdiğiniz adresten konum bulunamadı. Lütfen haritadan seçin.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setAddressNotFoundModalOpen(false);
                setMapModalOpen(true);
              }}
              variant="contained"
            >
              Haritadan Seç
            </Button>
            <Button onClick={() => setAddressNotFoundModalOpen(false)}>
              Kapat
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={paymentModalOpen}
          onClose={() => setPaymentModalOpen(false)}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle>Online Ödeme</DialogTitle>
          <DialogContent>
            {iframeSrc ? (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight={400}
              >
                <iframe
                  src={iframeSrc}
                  title="3D Secure"
                  style={{ width: '100%', height: '400px', border: 'none' }}
                />
              </Box>
            ) : (
              <Box display="flex" flexDirection="column" gap={2} mt={1}>
                <TextField
                  label="Kart Üzerindeki İsim"
                  fullWidth
                  value={cardName}
                  onChange={(e) => setCardName(e.target.value)}
                  error={!!paymentFormErrors.cardName}
                  helperText={paymentFormErrors.cardName}
                />
                <TextField
                  label="Kart Numarası"
                  fullWidth
                  value={cardNumber}
                  onChange={handleCardNumberChange}
                  placeholder="0000 0000 0000 0000"
                  inputProps={{ maxLength: 19 }}
                  error={!!paymentFormErrors.cardNumber}
                  helperText={paymentFormErrors.cardNumber}
                />
                <Box display="flex" gap={2}>
                  <TextField
                    label="Son K. T."
                    fullWidth
                    value={expiredDate}
                    onChange={handleExpiryDateChange}
                    placeholder="AA/YY"
                    inputProps={{ maxLength: 5 }}
                    error={!!paymentFormErrors.expiredDate}
                    helperText={paymentFormErrors.expiredDate}
                  />
                  <TextField
                    label="CVV"
                    fullWidth
                    value={cvv}
                    onChange={handleCvvChange}
                    placeholder="123"
                    inputProps={{ maxLength: 3 }}
                    error={!!paymentFormErrors.cvv}
                    helperText={paymentFormErrors.cvv}
                  />
                </Box>
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            {!iframeSrc && (
              <>
                <Button
                  onClick={() => setPaymentModalOpen(false)}
                  color="inherit"
                >
                  İptal
                </Button>
                <Button
                  variant="contained"
                  disabled={false}
                  onClick={handleProceedToPayment}
                >
                  Ödemeyi Tamamla
                </Button>
              </>
            )}
          </DialogActions>
        </Dialog>
        <Dialog
          open={cashPosModalOpen}
          onClose={() => setCashPosModalOpen(false)}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle>Ödeme Onayı</DialogTitle>
          <DialogContent>
            <Typography>
              {pendingPaymentType === 'current'
                ? 'Cari hesap üzerinden gönderi oluşturulacaktır. Onaylıyor musunuz?'
                : 'Müşteriden ödemeyi aldığınızı onaylayarak gönderiyi oluşturun.'}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setCashPosModalOpen(false)}>Vazgeç</Button>
            <Button
              variant="contained"
              onClick={handleConfirmCashPosPayment}
              disabled={isSubmitting}
            >
              {isSubmitting ? <CircularProgress size={24} /> : 'Onayla'}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={orderLoading}>
          <DialogContent>
            <CircularProgress />
          </DialogContent>
        </Dialog>
      </Stack>
    </>
  );
}
